import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Gazetters from './Gazetters';
import Requests from './Requests';

class Charts extends React.PureComponent {
    render() {
        const { current, until, from } = this.props;

        return (
            <React.Fragment>
                {
                    current.user
                        ?
                        <React.Fragment>
                            { current.addGazeteer.length > 0 ? <Gazetters gazetters={current.addGazeteer} until={until} from={from} /> : '' }
                            { current.addRequest.length > 0 ? <Requests requests={current.addRequest} until={until} from={from}  /> : ''}
                        </React.Fragment>
                        :
                        ''
                }
            </React.Fragment>
        );
    }
}

export default connect(
    (state, { from, until, current }) => {
        return {
            from,
            until,
            current,
        };
    },
    dispatch => bindActionCreators({}, dispatch),
)(Charts);



// WEBPACK FOOTER //
// ./app/components/Statistics/St/Charts/index.js